import { FlexDiv } from 'components/generic/HomePageComponents'

export const TopCitiesMainContainer = (props) => {
  return (
    <FlexDiv
      flexDirection='row'
      width='100%'
      justifyContent='center'
      bg='textColor'
      paddingBottom='10px'
    >
      <FlexDiv
        flexDirection='column'
        maxWidth={['90vw', '100vw', '992px']}
        flexWrap='wrap'
        {...props}
      />
    </FlexDiv>
  )
}

export default TopCitiesMainContainer
